$(document).ready(function() {
    // Abre la sección por defecto
    $('#accordion-custom h3[data-default-open]').next().slideDown();
    $('#accordion-custom h3[data-default-open]').addClass('active');

    $('#accordion-custom section h3').click(function() {
        // Cierra todos los divs dentro de las secciones
        $('#accordion-custom section div.container-section').slideUp();
        $('#accordion-custom section h3').removeClass('active');

        // Abre el div siguiente (contenido del acordeón) si está cerrado
        if(!$(this).next().is(':visible')) {
            $(this).next().slideDown();
            $(this).addClass('active');
        }
    });
});